/* import __COLOCATED_TEMPLATE__ from './legacy-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();